const translation = {
  "home": "Início",
  "services": "Serviços",
  "contact": "Contato",
  "login": "Iniciar Sessão",
  "loginNow": "Iniciar Sessão Agora",
  "findMyDoctor": "Encontrar Meu Médico",
  "registerAsVendor": "Registrar como Fornecedor",
  "searchPlaceholder": "Pesquisar produtos, serviços...",
  "welcomeMessage": "Bem-vindo ao Aryal Care",
  "currentLanguage": "Idioma Atual",
  "phone": "Telefone",
  "email": "E-mail",
  "address": "Endereço",
  "information": "Informação",
  "aboutUs": "Sobre Nós",
  "contactUs": "Contate-nos",
  "privacyPolicy": "Política de Privacidade",
  "terms": "Termos e Condições",
  "deliveryInfo": "Informação de Envio",
  "ordersReturns": "Pedidos e Devoluções",
  "customerCare": "Atendimento ao Cliente",
  "help": "Ajuda e Perguntas Frequentes",
  "myAccount": "Minha Conta",
  "orderHistory": "Histórico de Pedidos",
  "wishlist": "Lista de Desejos",
  "newsletter": "Boletim de Notícias",
  "purchasingPolicy": "Política de Compra",
  "newsletterText": "Inscreva-se na nossa lista de e-mail para receber as últimas atualizações e ofertas.",
  "enterEmail": "Digite seu endereço de e-mail",
  "subscribeNow": "Inscreva-se Agora",
  "copyright": "Direitos autorais",
  "freeShipping": "Frete Grátis",
  "freeShippingText": "Frete grátis para todo o mundo",
  "support24_7": "Suporte 24/7",
  "support24_7Text": "Contate-nos 24 horas por dia",
  "securePayments": "Pagamentos Seguros",
  "securePaymentsText": "Proteção de pagamento 100%",
  "easyReturn": "Devolução Fácil",
  "easyReturnText": "Política de devoluções simples",
  "title": "Categorias",
  "scan": "Exame",
  "laboratory": "Laboratório",
  "miscellaneous": "Diversos",
  "procedure": "Procedimento",
  "consumables": "Consumíveis",
  "pharmacy": "Farmácia",
  "itemsFor": "Itens de {category}",
  "categoryContent": "Conteúdo para a categoria {category} apareceria aqui.",
  "shopNow": "Compre Agora",
  "yes": "Sim",
  "no": "Não",
  "ok": "Ok",
  "cancel": "Cancelar",
  "logout": "Sair",
  "logoutConfirmMessage": "Você tem certeza que deseja sair?",
  "confirm": "Confirmar",
  "banners": {
    "title": "Banners",
    "web_banners": "Banners Web",
    "app_banners": "Banners App",
    "hero_banner": "Banner Principal",
    "hero_small_top": "Banner Principal Pequeno Superior",
    "hero_small_bottom": "Banner Principal Pequeno Inferior",
    "deals_banner": "Banner de Ofertas",
    "banner1": "Banner 1",
    "banner2": "Banner 2",
    "health_tip": "Dica de Saúde",
    "hero_banner_bottom": "Banner Principal Inferior",
    "product_hero_banner": "Banner Principal de Produto",
    "middle_banner": "Banner Médio",
    "middle_small_banner": "Banner Médio Pequeno",
    "lower_midline_banner": "Banner de Linha Média Inferior",
    "Hero Banner": "Banner Principal",
    "Hero Banner Top": "Banner Principal Superior",
    "Health Tip": "Dica de Saúde",
    "Hero Banner Product": "Banner Principal de Produto",
    "Primary banner": "Banner Principal",
    "Secondary Banner": "Banner Secundário",
    "Tertiary Banner": "Banner Terciário",
    "Hero banner Top": "Banner Principal Superior",
    "Health Banner": "Banner de Saúde",
    "Hero Banner Bottom": "Banner Principal Inferior",
    "Product Banner": "Banner de Produto",
    "update": "Atualizar",
    "ID": "ID",
    "Title": "Título",
    "Screen type": "Tipo de Tela",
    "Width": "Largura",
    "Height": "Altura",
    "Price": "Preço",
    "noBannerData": "Nenhum dado de banner encontrado.",
    "invalidImageFile": "Arquivo de imagem inválido.",
    "pleaseSelectImage": "Por favor selecione um arquivo de imagem.",
    "failedToUpdate": "Falha ao atualizar a imagem do banner.",
    "updateBannerImage": "Atualizar Imagem do Banner",
    "chooseNewImage": "Escolher Nova Imagem",
    "requiredSize": "Tamanho requerido: {{width}}x{{height}}px, Máx {{maxSize}}MB",
    "uploading": "Enviando...",
    "updateImage": "Atualizar Imagem",
    "chooseFile": "Escolher Arquivo",
    "noFileChosen": "Nenhum arquivo escolhido",
    "updatedSuccessfully": "Banner atualizado com sucesso",
    "invalidDimensions": "As dimensões da imagem devem ser {{width}}x{{height}}px"
  },

  "loginPage": {
    "subtitle": "Acesse seu painel de fornecedor para gerenciar seus serviços de saúde.",
    "username": "Nome de usuário",
    "usernamePlaceholder": "Digite seu nome de usuário",
    "password": "Senha",
    "passwordPlaceholder": "Digite sua senha",
    "forgotPassword": "Esqueceu a senha?",
    "loginButton": "Iniciar Sessão",
    "loggingIn": "Iniciando sessão...",
    "loginFailed": "Falha ao iniciar sessão",
    "errorMessages": {
      "invalidCredentials": "Usuário ou senha incorretos",
      "invalidUser": "Tipo de usuário inválido. Acesse sua conta através de: ",
      "serverError": "Erro do servidor, por favor tente novamente mais tarde",
      "networkError": "Erro de rede, por favor verifique sua conexão",
      "required": "Por favor preencha este campo"
    }
  },
  "vendorRegistration": {
    "idCard": {
      "idcard_type": "Tipo de Documento de Identificação",
      "idcard_no": "Número do Documento de Identificação",
      "enter_number": "Digite o número do documento",
      "dni": "DNI",
      "dni_description": "Digite o número de DNI de 8 dígitos",
      "ce": "Carteira de Estrangeiro",
      "ce_description": "Digite o número da carteira de estrangeiro de 12 dígitos",
      "pas": "Passaporte",
      "pas_description": "Digite o número do passaporte",
      "pe": "Identificação Empresarial",
      "pe_description": "Digite o número de identificação empresarial",
      "cof": "Outro Documento",
      "cof_description": "Digite o número do documento"
    },
    "title": "Registro de Fornecedor",
    "headers": {
      "step1": "Registrar como Fornecedor",
      "step2": "Tipo de Fornecedor",
      "step3": "Detalhes do Fornecedor",
      "step4": "Endereço",
      "step5": "Detalhes da Conta",
      "step6": "Pré-visualizar e Enviar",
      "step7": "Revise todas as informações antes de enviar seu registro."
    },
    "descriptions": {
      "step1": "Preencha o formulário para se registrar como Fornecedor. Estamos animados em incluir sua experiência em nossa rede de saúde digital.",
      "step2": "Pronto para se conectar com clínicas e hospitais digitalmente? Registre-se agora para mostrar seus serviços ao público certo.",
      "step3": "Forneça detalhes sobre sua organização ou prática médica.",
      "step4": "Informe-nos onde seus serviços operam. Garantiremos que as conexões certas cheguem até você.",
      "step5": "Forneça informações bancárias para transações.",
      "step6": "Revise todas as informações antes de enviar seu registro.",
      "step7": "Obrigado por se registrar como fornecedor em nossa plataforma. Seu registro foi recebido e está em análise. Nossa equipe verificará seus detalhes e aprovará sua solicitação em breve. Você será notificado por e-mail assim que seu registro for aprovado."
    },
    "subdescriptions": {
      "step1": "Complete os detalhes de registro.",
      "step2": "Por favor, selecione o serviço no qual está interessado.",
      "step3": "Complete os detalhes do fornecedor.",
      "step4": "Insira os detalhes do fornecedor abaixo para completar seu registro.",
      "step5": "Complete os detalhes da conta.",
      "step6": "Revise todas as informações antes de enviar seu registro."
    },
    "formLabels": {
      "name": "Nome da Organização",
      "adminName": "Nome do Administrador",
      "userName": "Nome de Usuário",
      "email": "E-mail",
      "phone": "Telefone",
      "emergencyPhone": "Telefone de Emergência",
      "password": "Senha",
      "confirmPassword": "Confirmar Senha",
      "vendorType": "Tipo de Fornecedor",
      "otherProfessional": "Outra Profissão",
      "accreditation": "Credenciamento",
      "regNumber": "Número de Registro",
      "deliveryRadius": "Raio de Entrega (km)",
      "website": "Site",
      "establishedYear": "Ano de Estabelecimento",
      "gst": "GST",
      "vat": "IVA",
      "street": "Rua",
      "city": "Cidade",
      "country": "País",
      "region": "Estado/Província",
      "zip": "CEP",
      "accountName": "Nome da Conta",
      "bankName": "Nome do Banco",
      "iban": "IBAN",
      "nid": "Número de Identificação",
      "accountAddress": "Endereço da Conta",
      "accountPhone": "Telefone da Conta"
    },
    "account": {
      "accountHolder": "Nome do titular da conta",
      "bankName": "Nome do banco",
      "iban": "Número da conta / IBAN",
      "swift": "Código SWIFT/BIC",
      "branchAddress": "Endereço da agência",
      "paymentMethod": "Método de pagamento preferido",
      "currency": "Selecione sua moeda",
      "uploadProof": "Envie um comprovante de conta",
      "uploadFile": "Enviar documento"
    },
    "common": {
      "selectOption": "Por favor selecione"
    },
    "placeholders": {
      "name": "Digite o nome da organização",
      "adminName": "Digite o nome do administrador",
      "userName": "Digite o nome de usuário",
      "email": "Digite o e-mail",
      "phone": "Digite o número de telefone",
      "emergencyPhone": "Digite o telefone de emergência",
      "password": "Digite a senha",
      "confirmPassword": "Confirme a senha",
      "accreditation": "Digite o credenciamento",
      "regNumber": "Digite o número de registro",
      "deliveryRadius": "Digite o raio de entrega",
      "website": "Digite a URL do site",
      "establishedYear": "Digite o ano de estabelecimento",
      "gst": "Digite o IVA",
      "street": "Digite o endereço",
      "city": "Digite a cidade",
      "country": "Selecione o país",
      "region": "Digite o estado/região",
      "zip": "Digite o CEP",
      "accountName": "Digite o nome da conta",
      "bankName": "Digite o nome do banco",
      "iban": "Digite o IBAN",
      "nid": "Digite o número de identificação",
      "accountAddress": "Digite o endereço da conta",
      "accountPhone": "Digite o telefone da conta",
      "singleUser": "único utilizador"
    },
    "errors": {
      "idCardAlreadyExists": "Os detalhes do cartão de identificação já estão registados",
      "idCardStartsWithZero": "O número do cartão de identificação não pode começar com 0",
      "invalidIdCardLength": "O comprimento do número do cartão de identificação é inválido",
      "minLength": "Deve ter pelo menos 3 caracteres",
      "required": "Este campo é obrigatório",
      "invalidEmail": "E-mail inválido",
      "passwordLength": "A senha deve ter pelo menos 8 caracteres",
      "passwordMismatch": "As senhas não coincidem",
      "invalidPhone": "Número de telefone inválido",
      "invalidWebsite": "URL do site inválida (inclua http:// ou https://)",
      "invalidYear": "Digite um ano válido (1800-atual)",
      "invalidGST": "GST inválido",
      "invalidZip": "CEP inválido",
      "passwordComplexity": "A senha deve conter 8 a 30 caracteres, uma letra minúscula, uma maiúscula, um número e um caractere especial",
      "This name is already registered": "Este nome já está registrado",
      "This phone is already registered": "Este telefone já está registrado",
      "This email is already registered": "Este e-mail já está registrado",
      "This accreditation is already registered": "Esta credencial já está registrada",
      "This reg_number is already registered": "Este número de registro já está registrado",
      "This user_name is already registered": "Este usuário já está registrado",
      "invalidFileType": "Apenas imagens (JPG/PNG) e arquivos PDF são permitidos."
    },
    "buttons": {
      "previous": "Passo Anterior",
      "next": "Próximo Passo",
      "submit": "Enviar Registro",
      "goBack": "Voltar"
    },
    "success": {
      "title": "Registro Bem-sucedido",
      "message": "Seu registro como fornecedor foi recebido e está em análise. Nossa equipe verificará seus detalhes e aprovará sua solicitação em breve. Você será notificado por e-mail assim que seu registro for aprovado."
    },
    "vendorTypes": {
      "hospital": "Hospital",
      "clinic": "clínica",
      "laboratory": "Laboratório",
      "pharmacy": "Farmácia",
      "diagnostic": "Centro de Diagnóstico",
      "singleDoctor": "Médico individual",
      "singleNurse": "Enfermeira individual",
      "other": "Outros profissionais"
    },
    "disclaimer": {
      "vatApplicable": "** É aplicável 13% de IVA em todos os planos pagos"
    },
    "subscriptionTypes": {
      "Basic": "Básico",
      "Free": "Plano Gratuito",
      "monthly": " Mensal",
      "yearly": " Anual"
    },
    "selectProfession": "Selecione sua profissão",
    "selectProfessionPlaceholder": "Por favor selecione"
  },
  "previewDetails": {
    "sections": {
      "registration": "Detalhes de registro",
      "vendorDetails": "Tipo e detalhes do fornecedor",
      "address": "Endereço",
      "transaction": "Detalhes da transação",
      "subscription": "Assinatura"
    },
    "labels": {
      "name": "Nome",
      "email": "E-mail",
      "phone": "Número de telefone",
      "emergencyPhone": "Número de emergência",
      "password": "Senha",
      "vendorType": "Tipo de fornecedor",
      "accreditation": "Credenciamento",
      "registerNumber": "Número de registro",
      "deliveryRadius": "Raio de entrega",
      "website": "Link do site",
      "establishedYear": "Ano de estabelecimento",
      "gst": "GST",
      "vat": "IVA",
      "street": "Nome da rua",
      "city": "Cidade",
      "country": "País",
      "region": "Região",
      "zip": "CEP",
      "accountHolder": "Nome do titular da conta",
      "bankName": "Nome do banco",
      "accountNumber": "Número da conta",
      "swiftCode": "Código SWIFT/BIC",
      "branchAddress": "Endereço da agência",
      "paymentMethod": "Método de pagamento preferido",
      "currency": "Moeda",
      "proofDocument": "Documento de comprovação"
    }
  },
  "registrationSuccess": {
    "title": "Registro Enviado com Sucesso",
    "successImageAlt": "Ícone de sucesso",
    "message1": "Obrigado por se registrar como fornecedor em nossa plataforma.",
    "message2": "Seu registro foi recebido e está em análise. Nossa equipe verificará seus detalhes e aprovará sua solicitação em breve. Você será notificado por e-mail assim que seu registro for aprovado.",
    "message3": "Se tiver alguma dúvida urgente, sinta-se à vontade para entrar em contato com nossa equipe de suporte.",
    "returnButton": "Voltar para o Início"
  },
  "dashboardMenu": {
    "vendors": "Fornecedores",
    "vendorLiabilities": "Passivos de Fornecedores",
    "patientLiabilities": "Passivos de Pacientes"
  },
  "registeredHospitals": {
    "vendors": "Fornecedores",
    "pending": "Pendente",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "searchClinic": "Pesquisar clínica",
    "searchID": "Pesquisar ID",
    "searchLocation": "Pesquisar localização",
    "all": "Todos",
    "modernMedicine": "Medicina Moderna",
    "ayurveda": "Ayurveda",
    "homeopathy": "Homeopatia",
    "unani": "Unani",
    "dental": "Odontologia",
    "multispeciality": "Multiespecialidade",
    "other": "Outro", "id": "ID",
    "clinic": "Fornecedor",
    "patients": "Pacientes",
    "category": "Categoria",
    "type": "Tipo de Fornecedor",
    "date": "Data",
    "location": "Localização",
    "noMoreApproved": "Não há mais lista aprovada para mostrar!!",
    "noMorePending": "Não há mais lista pendente para mostrar!!",
    "noMoreRejected": "Não há mais lista rejeitada para mostrar!!",
    "noMoreExpired": "Não há mais lista expirada para mostrar!!"
  },
  "common": {
    "ok": "OK",
    "yes": "Sim",
    "no": "Não",
    "notAvailable": "Não Disponível"
  },
  "hospitalDetails": {
    "navigation": {
      "home": "Início",
      "bankingInfo": "Informações Bancárias",
      "reports": "Relatórios",
      "liabilities": "Passivos"
    },
    "buttons": {
      "vendors": "Fornecedores",
      "approve": "Aprovar",
      "reject": "Rejeitar",
      "delete": "Excluir",
      "activate": "Ativar",
      "deactivate": "Desativar"
    },
    "fields": {
      "id": "ID",
      "registrationNumber": "Número de Registro",
      "vendorType": "Tipo de Fornecedor",
      "username": "Nome de Usuário",
      "establishedYear": "Ano de Estabelecimento",
      "email": "E-mail",
      "location": "Localização",
      "phoneNumber": "Número de Telefone",
      "emergencyNumber": "Número de Emergência",
      "website": "Site",
      "plan": "Plano de Assinatura",
    },
    "messages": {
      "approvedSuccessfully": "Aprovado com Sucesso",
      "deletedSuccessfully": "Excluído com Sucesso",
      "activatedSuccessfully": "Ativado com Sucesso",
      "deactivatedSuccessfully": "Desativado com Sucesso",
      "rejectedSuccessfully": "Prestador de Serviços rejeitado com sucesso",
      "failedToSubmit": "Falha ao enviar dados",
      "failedToReject": "Falha ao rejeitar",
      "errorSubmission": "Erro no Envio de Dados. Por favor, tente novamente!",
      "errorInData": "Erro nos Dados",
      "providerDeleted": "Este Provedor Está Excluído"
    },
    "confirmations": {
      "delete": "Tem certeza de que deseja excluir este provedor?",
      "activate": "Tem certeza de que deseja ativar este provedor?",
      "deactivate": "Tem certeza de que deseja desativar este provedor?",
      "areYouSure": "Tem certeza?"
    },
    "id": "Fornecedor ID",
    "registrationNumber": "Número de Registro",
    "healthCareType": "Tipo de Assistência Médica",
    "vendorType": "Tipo de Fornecedor",
    "establishedYear": "Ano de Estabelecimento",
    "email": "E-mail",
    "location": "Localização",
    "phoneNumber": "Número de Telefone",
    "emergencyNumber": "Número de Emergência",
    "deliveryRadius": "Raio de Entrega (km)",
    "website": "Website",
    "reject": "Rejeitar",
    "approve": "Aprovar",
    "delete": "Excluir",
    "deactivate": "Desativar",
    "activate": "Ativar",
    "areYouSure": "Tem certeza?",
    "approvedSuccessfully": "Aprovado com sucesso",
    "serviceProviderRejected": "Prestador de Serviço rejeitado com sucesso",
    "failedToSubmit": "Falha ao enviar dados",
    "failedToReject": "Falha ao rejeitar",
    "errorInData": "Erro na recuperação de dados. Por favor, tente novamente!",
    "deleteConfirmation": "Tem certeza que deseja excluir este Prestador de Serviço?",
    "activateConfirmation": "Tem certeza que deseja ativar este Prestador de Serviço?",
    "deactivateConfirmation": "Tem certeza que deseja desativar este Prestador de Serviço?",
    "deletedSuccessfully": "Excluído com sucesso",
    "activatedSuccessfully": "Ativado com sucesso",
    "deactivatedSuccessfully": "Desativado com sucesso",
    "clinics": "Fornecedores",
    "home": "Início",
    "bankingInfo": "Informações Bancárias",
    "reports": "Relatórios",
    "notAvailable": "Não Disponível",
    "thisProviderIsDeleted": "Este prestador de serviços está excluído"
  },
  "bankingInfo": {
    "accountHolder": "Nome do titular da conta",
    "bankName": "Nome do banco",
    "accountNumber": "Número da conta / IBAN",
    "swiftCode": "Código SWIFT/BIC",
    "branchAddress": "Endereço da agência",
    "paymentMethod": "Método de pagamento preferido",
    "currency": "Moeda",
    "proofDocument": "Documento de comprovação",
    "subscriptionPlan": "Plano de assinatura",
    "noBankInfo": "Não há informações bancárias disponíveis"
  },
  "paymentMethods": {
    "cash": "Dinheiro",
    "card": "Cartão",
    "cod": "Pagamento na entrega",
    "benefit_pay": "Pagamento de benefícios",
    "upi": "UPI"
  },
  "currencies": {
    "eur": "Euro",
    "inr": "Rupia indiana",
    "usd": "Dólar americano",
    "crc": "Colón costa-riquenho"
  },
  "professionalsList": {
    "Hospital": "Hospital",
    "Clinic": "Clínica",
    "Laboratory": "Laboratório",
    "Pharmacy": "Farmácia",
    "Diagnostic": "Centro de Diagnóstico",
    "Single Doctor": "Médico individual",
    "Single Nurse": "Enfermeira individual",
    "General Practitioners": "Clínicos Gerais",
    "Therapists": "Terapeutas",
    "Neurodevelopmental Specialists": "Especialistas em Neurodesenvolvimento",
    "Specialist Doctors": "Médicos Especialistas",
    "Dentists": "Dentistas",
    "Odontologists": "Odontólogo",
    "Nurses": "Enfermeiros/Enfermeiras",
    "Patient Assistants": "Assistentes de Paciente",
    "Psychologists": "Psicólogos",
    "Nutritionists": "Nutricionistas",
    "Physiotherapists": "Fisioterapeutas",
    "Respiratory Therapists": "Terapeutas Respiratórios",
    "Electrocardiography": "Eletrocardiografia",
    "Speech Therapists": "Fonoaudiólogos"
  },
  "otpVerification": {
    "title": "Verifique seus dados",
    "completeVerification": "Concluir verificação",
    "bothMustVerify": "Tanto o e-mail quanto o telefone devem ser verificados antes de continuar",
    "emailVerification": "Verificação de e-mail",
    "phoneVerification": "Verificação de telefone",
    "verified": "Verificado",
    "verifyEmail": "Verificar e-mail",
    "verifyPhone": "Verificar telefone",
    "enterOTP": "Digite o OTP",
    "resendOTP": "Reenviar OTP",
    "sending": "Enviando...",
    "verifying": "Verificando...",
    "submit": "Enviar",
    "cancel": "Cancelar",
    "proceedRegistration": "Continuar com o cadastro",
    "email": "E-mail",
    "phone": "Telefone",
    "complete": "Completo",
    "successMessages": {
      "email": "E-mail verificado com sucesso",
      "phone": "Telefone verificado com sucesso",
      "otpSent": "OTP enviado para seu {{method}}"
    },
    "errorMessages": {
      "invalidOTP": "OTP inválido. Por favor tente novamente.",
      "verificationFailed": "Falha na verificação. Por favor tente novamente.",
      "sendFailed": "Falha ao enviar OTP. Tente novamente!",
      "enterOTP": "Por favor digite o OTP",
      "verifyBoth": "Por favor verifique tanto o e-mail quanto o telefone antes de continuar"
    }
  },
  "serviceCatalogue": {
    "id": "Fornecedor ID",
    "searchByService": "Pesquisar por Serviço ou Descrição",
    "searchByVendorId": "Pesquisar por ID do Fornecedor",
    "searchByVendorName": "Pesquisar por Nome do Fornecedor",
    "services": "Serviços",
    "createdAt": "Criado em",
    "vendor": "Fornecedor",
    "duration": "Duração",
    "fee": "Taxa",
    "serviceMode": "Modo de Serviço",
    "home": "Casa",
    "lab": "Clínica",
    "category": "Categoria",
    "subcategory": "Subcategoria",
    "description": "Descrição",
    "shortDescription": "Descrição Curta",
    "loading": "Carregando..."
  },
  "liability": {
    "title": "Passivos",
    "loading": "Carregando...",
    "failedToLoad": "Falha ao carregar passivos",
    "noLiabilities": "Nenhum passivo encontrado.",
    "table": {
      "id": "ID",
      "item": "Item",
      "request": "Solicitação",
      "paidAmount": "Valor pago",
      "totalAmount": "Valor total",
      "liability": "Passivo"
    },
    "invoiceButton": "Fatura",
    "invoice": "Fatura",
    "openInvoice": "Abrir fatura",
    "noDownload": "Nenhuma fatura disponível para download.",
    "email": "Email"
  },
  "ok": "OK",
  "invoice": {
    "title": "Fatura",
    "invoiceTitle": "FATURA",
    "loading": {
      "loadingInvoice": "A carregar fatura..."
    },
    "alerts": {
      "paymentRecorded": "Pagamento registado com sucesso!",
      "failedToSave": "Falha ao guardar o pagamento. Por favor, tente novamente.",
      "enterTransactionRef": "Por favor, introduza o número de referência da transação",
      "identificationNotUpdated": "O número de identificação não está atualizado, pelo que não é possível proceder com o pagamento",
      "leadingSpacesNotAllowed": "Espaços iniciais não são permitidos"
    },
    "buttons": {
      "print": "Imprimir",
      "saveAndPay": "Guardar e Pagar",
      "saving": "A guardar..."
    },
    "labels": {
      "date": "Data",
      "itemService": "Item/Serviço",
      "issuedDate": "Data de Emissão",
      "total": "Total",
      "payable": "A Pagar",
      "transactionRef": "Número de Referência da Transação *",
      "remarks": "Observações"
    },
    "placeholders": {
      "transactionRef": "Introduza o número de referência da transação",
      "remarks": "Introduza observações adicionais"
    },
    "defaults": {
      "license": "Licença"
    },
    "notes": {
      "printWarning": "** Caso a opção 'Imprimir' não funcione, verifique se o bloqueador de pop-ups está 'desligado' nas definições do seu navegador.",
      "priceIncludesTax": "** O preço inclui todos os impostos aplicáveis"
    }
  },
  "productCatalogue": {
    "headers": {
      "productName": "Nome do Produto",
      "catalogueId": "ID do Catálogo",
      "quantityInStock": "Quantidade em Estoque",
      "vendor": "Fornecedor",
      "vendorId": "ID do Fornecedor",
      "createdAt": "Criado em"
    }
  },
  "liabilities": {
    "title": "Passivos de Fornecedores",
    "all": "Todos os Passivos",
    "paid": "Pagos",
    "searchHospitalName": "Pesquisar por nome do hospital",
    "searchHospitalID": "Pesquisar por ID do hospital",
    "hospitalID": "ID do Hospital",
    "hospitalName": "Nome do Hospital",
    "billType": "Tipo de Fatura",
    "liability": "Passivo",
    "billDate": "Data da Fatura",
    "renewalDate": "Data de Renovação",
    "status": "Estado",
    "noLiabilities": "Nenhum passivo encontrado",
    "noPaidLiabilities": "Nenhum passivo pago encontrado"
  }
};

export default translation;